import axios from "axios";
import Cookies from "js-cookie";

const apiClient = axios.create({
  baseURL: `${process.env.VUE_APP_API_BASE_URL}/api`, // API Base URL
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

apiClient.interceptors.request.use((config) => {
  const xsrfToken = Cookies.get("XSRF-TOKEN");
  if (xsrfToken) {
    config.headers["X-XSRF-TOKEN"] = decodeURIComponent(xsrfToken);
  }
  return config;
});

export default apiClient;
